export default function useGetTitle({ productType, title }) {
  return productType ?? title ?? '';
}
